export const validation = {
    thanksTitleMax:40,
    thanksMemoMax:250,
    memberNameMax:16,
    memberMemoMax:250,
}